import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  // {
  //   path: '/',
  //   redirect: '/login',
  //   component: () => import('@/views/login/index'),
  //   hidden: true,
  // },
  // {
  //   path: '/login',
  //   component: () => import('@/views/login/index'),
  //   hidden: true
  // },
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/views/login3/index'),
    hidden: true,
  },
  {
    path: '/login',
    component: () => import('@/views/login3/index'),
    hidden: true
  },
  {
    path: '/login2',
    component: () => import('@/views/login2/index'),
    hidden: true
  },
  {
    path: '/bpwechat',
    component: () => import('@/views/bpwechat-login/index'),
    hidden: true
  },
  {
    path: '/iframe',
    component: () => import('@/views/iframe/index'),
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
